import React, { useState } from 'react';
import logoText from '@assets/logo.png';
import { Card } from '@components/atoms/Card';
import { isMobileDevice } from '@utils/isMobileDevice';

export const APP_STORE_URL = 'https://apps.apple.com/us/app/zenhammer/id1535120529';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.edwin.zenhammer';

const MobileOnly: React.FC = () => {
  const [isMobile] = useState(() => isMobileDevice());

  return (
    <div className="flex flex-col gap-10 items-center justify-center min-h-screen bg-indigo-950 dark:bg-neutral-900 p-4">
      <img
        src={logoText}
        alt="App usage info"
        className="max-w-sm w-full mb-4 md:mb-0 md:mr-6"
      />

      <Card className="max-w-md bg-white dark:bg-gray-800 rounded-xl shadow-lg p-6">
        <div>
          {isMobile ? (
            <>
              <h1 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                Get the ZenHammer app
              </h1>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-6">
                ZenHammer runs best on your phone through our app. Download it
                to manage your projects anywhere.
              </p>
            </>
          ) : (
            <>
              <h1 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                Make your window a bit wider
              </h1>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed mb-6">
                ZenHammer&apos;s web view needs a little more room to show
                everything. Widen your browser window to keep going.
              </p>
              <p className="text-gray-600 dark:text-gray-400 text-sm mb-3">
                On a phone instead? Get the app:
              </p>
            </>
          )}

          <div className="flex flex-col gap-3">
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-black text-white rounded-lg px-4 py-3 hover:bg-gray-800 transition-colors">
              <svg
                className="w-6 h-6"
                viewBox="0 0 24 24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M18.71 19.5C17.88 20.74 17 21.95 15.66 21.97C14.32 22 13.89 21.18 12.37 21.18C10.84 21.18 10.37 21.95 9.09997 22C7.78997 22.05 6.79997 20.68 5.95997 19.47C4.24997 17 2.93997 12.45 4.69997 9.39C5.56997 7.87 7.12997 6.91 8.81997 6.88C10.1 6.86 11.32 7.75 12.11 7.75C12.89 7.75 14.37 6.68 15.92 6.84C16.57 6.87 18.39 7.1 19.56 8.82C19.47 8.88 17.39 10.1 17.41 12.63C17.44 15.65 20.06 16.66 20.09 16.67C20.06 16.74 19.67 18.11 18.71 19.5ZM13 3.5C13.73 2.67 14.94 2.04 15.94 2C16.07 3.17 15.6 4.35 14.9 5.19C14.21 6.04 13.07 6.7 11.95 6.61C11.8 5.46 12.36 4.26 13 3.5Z" />
              </svg>
              <div className="flex flex-col items-start">
                <span className="text-xs">Download on the</span>
                <span className="text-sm font-semibold">App Store</span>
              </div>
            </a>

            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-black text-white rounded-lg px-4 py-3 hover:bg-gray-800 transition-colors">
              <svg
                className="w-6 h-6"
                viewBox="0 0 24 24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg">
                <path d="M3.609 1.814L13.792 12 3.61 22.186a.996.996 0 0 1-.61-.92V2.734a1 1 0 0 1 .609-.92zm10.89 10.893l2.302 2.302-10.937 6.333 8.635-8.635zm3.199-3.198l2.807 1.626a1 1 0 0 1 0 1.73l-2.808 1.626L15.206 12l2.492-2.491zM5.864 2.658L16.8 8.99l-2.302 2.302-8.634-8.634z" />
              </svg>
              <div className="flex flex-col items-start">
                <span className="text-xs">Get it on</span>
                <span className="text-sm font-semibold">Google Play</span>
              </div>
            </a>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default MobileOnly;
